// What a simulated run takes (F3-2 "Input & environment", F3-3 Test call): the test applicant and, per endpoint the
// workflow calls, which saved lender reply (test event) to answer with. Default = each endpoint's first happy reply.
import { TEST_APPLICANTS } from '@/fixtures/flows'
import { defaultReply } from '@/lib/flowEngine'
import { endpointLabel } from '@/lib/endpoints'
import type { Batch, FlowNode } from '@/types'

export function endpointsOf(nodes: FlowNode[]): string[] {
  return Array.from(new Set(nodes.filter((n) => n.kind === 'api' && n.endpoint).map((n) => n.endpoint!)))
}

export function ApplicantPicker({ value, onChange, id = 'test-applicant' }: { value: string; onChange: (v: string) => void; id?: string }) {
  return (
    <div>
      <label className="label" htmlFor={id}>Test applicant</label>
      <select id={id} className="input" value={value} onChange={(e) => onChange(e.target.value)}>
        {TEST_APPLICANTS.map((a) => <option key={a.id} value={a.id}>{a.label}</option>)}
      </select>
    </div>
  )
}

export function ReplyPicker({ batch, routes, value, onChange }: { batch: Batch | undefined; routes: string[]; value: Record<string, string>; onChange: (v: Record<string, string>) => void }) {
  if (!batch) return <p className="text-2xs text-muted">No batch: nothing to answer with.</p>
  return (
    <div>
      <div className="mb-1 flex items-center justify-between">
        <span className="label !mb-0">Lender replies (saved test events)</span>
        <button type="button" className="btn btn-ghost btn-sm" onClick={() => onChange({})} disabled={!Object.keys(value).length}>Happy path</button>
      </div>
      <div className="space-y-1.5">
        {routes.map((route) => {
          const mine = batch.tests.filter((t) => t.endpoint === route)
          const def = defaultReply(batch.tests, route)
          return (
            <div key={route} className="grid grid-cols-[96px_1fr] items-center gap-2">
              <code className="truncate text-2xs" title={route}>{endpointLabel(route)}</code>
              <select className="input !min-h-7 py-0.5 text-2xs" aria-label={`Reply for ${endpointLabel(route)}`} value={value[route] ?? def?.id ?? ''} onChange={(e) => onChange({ ...value, [route]: e.target.value })}>
                {mine.length === 0 && <option value="">no test event (no reply)</option>}
                {mine.map((t) => <option key={t.id} value={t.id}>{t.name} · {t.reply.status} → {t.expectedOutcome}</option>)}
              </select>
            </div>
          )
        })}
        {routes.length === 0 && <p className="text-2xs text-muted">The workflow calls no endpoint yet.</p>}
      </div>
    </div>
  )
}
